import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-left-sidebar',
  templateUrl: './left-sidebar.component.html',
  styleUrls: ['./left-sidebar.component.css']
})
export class LeftSidebarComponent implements OnInit {
  curUrl = "";
  constructor(private router: Router) { }

  ngOnInit() {
    let tempUrl = this.router.url.split('/');
    this.curUrl = tempUrl.pop();
  }

  changePage(page) {
    this.curUrl = page;
  }

  closeSidebar() {
    const body = document.querySelector('body');
    body.classList.remove('pmd-body-open');

    const sidebar = document.querySelector('.pmd-sidebar-left');
    sidebar.classList.remove('pmd-sidebar-open');

    const overlay = document.querySelector('.pmd-sidebar-overlay');
    overlay.classList.remove('pmd-sidebar-overlay-active');
  }

}
